import { useTranslation } from 'react-i18next';
import type { ReactElement } from 'react';
import { Sun, Moon, Monitor } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useTheme, type Theme } from './useTheme';

const NEXT: Record<Theme, Theme> = {
  light: 'dark',
  dark: 'system',
  system: 'light',
};

export function ThemeToggle(): ReactElement {
  const { t } = useTranslation();
  const { theme, setTheme } = useTheme();

  const Icon = theme === 'light' ? Sun : theme === 'dark' ? Moon : Monitor;
  const next = NEXT[theme];

  const label = t(`theme.modes.${theme}`, {
    defaultValue: theme === 'light' ? 'Light' : theme === 'dark' ? 'Dark' : 'System',
  });
  const nextLabel = t(`theme.modes.${next}`, {
    defaultValue: next === 'light' ? 'Light' : next === 'dark' ? 'Dark' : 'System',
  });
  const title = t('theme.toggleTitle', {
    current: label,
    next: nextLabel,
    defaultValue: `Theme: ${label}. Click for ${nextLabel}.`,
  });

  return (
    <Button
      variant="ghost"
      onClick={() => setTheme(next)}
      title={title}
      aria-label={title}
      className="h-9 w-9 p-0"
    >
      <Icon className="h-4 w-4" />
    </Button>
  );
}
